import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../auth/service/utils.service";
import { locale as customerIt } from "./i18n/customer.lang-it";
import customerSettingsLinks from "./customer.settings-list";
import { RouterModule } from "@angular/router";
import customerRoutes from "./customer.routes";
import customerMenu from "./customer.menu";
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { CustomersReferentsListComponent } from "./pages/referents/customers-referents-list.component";
import { StatsComponent } from "./pages/stats/stats.component";
import { CustomersSitesListComponent } from "./pages/site/list/customers-sites-list.component";
import { CustomersSiteEditFormComponent } from "./pages/site/edit-form/customers-site-edit-form.component";
import { CustomersSiteAddFormComponent } from "./pages/site/add-form/customers-site-add-form.component";
import { LayoutModule } from "../../layout/layout.module";
import { FormAddCustomerReferentComponent } from "./components/form-add-customer-referent/form-add-customer-referent.component";
import { FormEditCustomerReferentComponent } from "./components/form-edit-customer-referent/form-edit-customer-referent.component";
import { CustomerDetailComponent } from "./pages/customer/detail/customer-detail.component";
import { CustomersEditFormComponent } from "./pages/customer/edit/customers-edit-form.component";
import { CustomersAddFormComponent } from "./pages/customer/add/customers-add-form.component";
import { CustomersListComponent } from "./pages/customer/list/customers-list.component";
import { CustomerTypeListComponent } from "./pages/customer-type/customer-type-list.component";
import { FteSubjectComponent } from "./pages/fte-subject/fte-subject.component";
import { TrackFinancialRelevanceComponent } from "./pages/track-financial-relevance/track-financial-relevance.component";
import { ServicesTracksComponent } from "./pages/services-tracks/services-tracks.component";
import { FormCustomerLogoUploadComponent } from "./components/form-customer-logo-upload/form-customer-logo-upload.component";
import { BanksListComponent } from "./pages/banks/banks-list.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { InvoiceModule } from "../invoice/invoice.module";

@NgModule({
  declarations: [
    CustomersAddFormComponent,
    CustomerDetailComponent,
    CustomersEditFormComponent,
    CustomersListComponent,
    CustomersReferentsListComponent,
    StatsComponent,
    CustomersSitesListComponent,
    CustomersSiteEditFormComponent,
    CustomersSiteAddFormComponent,
    FormAddCustomerReferentComponent,
    FormEditCustomerReferentComponent,
    CustomerTypeListComponent,
    FteSubjectComponent,
    TrackFinancialRelevanceComponent,
    ServicesTracksComponent,
    FormCustomerLogoUploadComponent,
    BanksListComponent,
  ],
  imports: [
    RouterModule.forChild(customerRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    NgbTooltipModule,
    LayoutModule,
    NgApexchartsModule,
    InvoiceModule,
  ],
  exports: [FormAddCustomerReferentComponent, FormEditCustomerReferentComponent, FteSubjectComponent],
})
export class CustomerModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("customer", customerIt, customerMenu, customerSettingsLinks);
  }
}
